export default __webpack_public_path__ + "static/media/IC00031-arrow_up_org.9227cb4d.svg";